const PURCHASE_VIDEO_EXAMPLES_ES = [
  "https://clapp-dev.s3.us-east-1.amazonaws.com/socialMedia/-O4IsuJUTOyUZujHJwNV/34fdcc46-a4ef-427a-8ff2-3878f733e98a.mp4",
  "https://clapp-dev.s3.us-east-1.amazonaws.com/socialMedia/-O4IsuJUTOyUZujHJwNV/cede29b6-2498-457d-9b6e-446eb25ca678.mp4",
  "https://clapp-dev.s3.us-east-1.amazonaws.com/socialMedia/-O4IsuJUTOyUZujHJwNV/b553a495-ed0e-4cc5-bce4-352cf1464e78.mp4",
];

const PURCHASE_VIDEO_EXAMPLES_EN = [
  "https://clapp-prod.s3.us-east-1.amazonaws.com/socialMedia/-Oqn1dn3aXEtzakQBesw/147730ca-91fc-448e-b8c3-5de372a324f3.mp4",
  "https://clapp-prod.s3.us-east-1.amazonaws.com/socialMedia/-Oqn1dn3aXEtzakQBesw/97358e7e-4b6e-433e-96f1-fa160aef02c6.mp4",
  "https://clapp-prod.s3.us-east-1.amazonaws.com/socialMedia/-Oqn1dn3aXEtzakQBesw/2cafd8c2-12e1-435e-9285-b626867c86ce.mp4",
];

export const getPurchaseVideoExamples = ({ language } = {}) => {
  if (language?.startsWith("es")) {
    return PURCHASE_VIDEO_EXAMPLES_ES;
  }

  if (language?.startsWith("en")) {
    return PURCHASE_VIDEO_EXAMPLES_EN;
  }

  return [];
};
